/**
 * The editor window (SPEC §3 "Default layout"): menu bar, toolbar, the dock
 * area, and the status bar. What every layout shares (shortcuts, dialogs, the
 * tour) is the ShellFrame's.
 */
import { useRef } from "react";
import { DockHost } from "./DockHost";
import { MenuBar } from "./MenuBar";
import { ShellFrame } from "./ShellFrame";
import type { MenuItems, TourOfferProp } from "./ShellFrame";
import { StatusBar } from "./StatusBar";
import { Toolbar } from "./Toolbar";
import "./shell.css";

export type EditorShellProps = TourOfferProp;

export function EditorShell({ tourOffer = null }: EditorShellProps) {
  const resetLayout = useRef<() => void>(() => undefined);

  // Window › Reset Layout is the dock's own: the compact layout has nothing to reset.
  const withResetLayout = (items: MenuItems): MenuItems => ({
    ...items,
    Window: [
      ...(items.Window ?? []),
      {
        label: "Reset Layout",
        run: () => {
          resetLayout.current();
        },
      },
    ],
  });

  return (
    <ShellFrame tourOffer={tourOffer} className="kn-shell-root" layout="desktop">
      {(menuItems) => (
        <>
          <MenuBar extraItems={withResetLayout(menuItems)} />
          <Toolbar />
          <main className="kn-shell-root__dock">
            <DockHost
              onResetAvailable={(reset) => {
                resetLayout.current = reset;
              }}
            />
          </main>
          <StatusBar />
        </>
      )}
    </ShellFrame>
  );
}
